import { techParametersMap, techParametersUnit } from './map';

/* 机组技术参数table */

export const filterTechParameters = function(data) {
  let dataArr = [];
  for (let key in data) {
    let name = techParametersMap[key];
    let unit = techParametersUnit[key];
    // let serial = indexMap[key];
    let value = data[key];
    // if (key === 'turbineType') {
    //   value = data[key] === 1 ? '直驱' : '双馈';
    // }
    if (name) {
      dataArr.push({
        quota: name,
        value,
        unit
      });
    }
  }
  return dataArr;
};

/* 机型对比信息table数据 */

export const filterCompareTechParameters = function(dataList, turbineList) {
  const list = [];
  for (let key in dataList[0]) {
    let name = techParametersMap[key];
    let unit = techParametersUnit[key];
    // let serial = indexMap[key];
    let row = { quota: name, unit };
    dataList.forEach(value => {
      turbineList.forEach((eco, index) => {
        if (value.turbineTypeId === parseInt(eco.turbineTypeId)) {
          row[`value${index === 0 ? '' : index}`] = value[key];
        }
      });
    });
    if (name) {
      list.push(row);
    }
  }
  return list;
};

/* 获取功率-推力曲线图表 */
export const filterPowerCurveData = function(data) {
  let initObj = { power: [], thrust: [] };
  return data.reduce((init, item) => {
    init.power.push([item.wspd, item.power]);
    init.thrust.push([item.wspd, item.thrust]);
    return init;
  }, initObj);
};

/* 处理多条功率曲线的table数据 */
export const filterCurveMoreTableData = function(
  data,
  type,
  subtype,
  wspdlist
) {
  // if (!type) {
  //   data = data.map(item => {
  //     return item;
  //   });
  // } else {
  //   if (type == 3 || type == 4) {
  //     data = data.map(arr => {
  //       let obj = {};
  //       arr = arr.reduce(function(prevArr, currentItem) {
  //         obj[currentItem.pointId]
  //           ? ''
  //           : (obj[currentItem.pointId] = true && prevArr.push(currentItem));
  //         return prevArr;
  //       }, []);
  //       if (type !== 10) {
  //         let wspdObj = {};
  //         arr = arr.reduce(function(prevArr, currentItem) {
  //           wspdObj[currentItem.wspd]
  //             ? ''
  //             : (wspdObj[currentItem.wspd] = true && prevArr.push(currentItem));
  //           return prevArr;
  //         }, []);
  //       }
  //       return arr;
  //     });
  //   } else {
  //     data = data.map(arr => {
  //       let obj = {};
  //       arr = arr.reduce(function(prevArr, currentItem) {
  //         obj[currentItem.pointid]
  //           ? ''
  //           : (obj[currentItem.pointid] = true && prevArr.push(currentItem));
  //         return prevArr;
  //       }, []);
  //       let wspdObj = {};
  //       arr = arr.reduce(function(prevArr, currentItem) {
  //         wspdObj[currentItem.wspd]
  //           ? ''
  //           : (wspdObj[currentItem.wspd] = true && prevArr.push(currentItem));
  //         return prevArr;
  //       }, []);
  //       return arr;
  //     });
  //   }
  // }
  let tableData = [];
  // if (type === 10) {
  //   // data[0].forEach(item => {
  //   //   let row = {};
  //   //   row.ratio = item.ratio;
  //   //   tableData.push(row);
  //   // });
  //   // data.forEach((arr, i) => {
  //   //   tableData.forEach((value, index) => {
  //   //     value[`power${i === 0 ? '' : i}`] = arr[index].value;
  //   //   });
  //   // });
  // } else {
  // let wspd = [];
  // for (let i = 0; i < data.length; i++) {
  //   data[i].forEach(value => {
  //     wspd.push(value.wspd);
  //   });
  // }
  // wspd.sort(function(a, b) {
  //   return a - b;
  // });
  // wspd = wspd.filter(function(item, index, arr) {
  //   return arr.indexOf(item, 0) === index;
  // });
  let wspd = wspdlist;
  for (let i = 0; i < wspd.length; i++) {
    let power;
    let obj = {
      wspd: wspd[i]
    };
    tableData.length = wspd.length;
    tableData[i] = obj;
    data.forEach((arr, temp) => {
      arr.forEach(item => {
        if (item.wspd === wspd[i]) {
          power = 'power' + `${temp === 0 ? '' : temp}`;
          temp = temp + 1;
          if (temp <= 1) {
            obj.wspd = wspd[i];
            if (!type) {
              if (subtype == '2') {
                obj[power] = item.thrust;
              } else {
                obj[power] = item.power;
              }
            } else {
              if (type === 4) {
                obj[power] = item.thrust;
              } else if (type === 3) {
                obj[power] = item.power;
              } else {
                obj[power] = item.power;
              }
            }
            // if (
            //   !tableData.some(item => {
            //     return item.wspd === wspd[i];
            //   })
            // ) {
            //   tableData.push(obj);
            // }
            // tableData.push(obj);
            tableData[i] = obj;
          } else {
            tableData.forEach(value => {
              if (value.wspd === wspd[i]) {
                value.wspd = wspd[i];
                if (!type) {
                  if (subtype == '2') {
                    value[power] = item.thrust;
                  } else {
                    value[power] = item.power;
                  }
                } else {
                  if (type === 4) {
                    value[power] = item.thrust;
                  } else if (type === 3) {
                    value[power] = item.power;
                  } else {
                    value[power] = item.power;
                  }
                }
              }
            });
          }
        }
      });
    });
  }
  // }
  return tableData;
};

/* 处理功率曲线多条图表 */
export const filterPowerCurveMoreData = function(data, type, subtype) {
  if (type === 5) {
    data = data.map(item => {
      return item;
    });
  } else {
    // if (type === 3 || type === 4) {
    //   data = data.map(arr => {
    //     let obj = {};
    //     arr = arr.reduce(function(prevArr, currentItem) {
    //       obj[currentItem.pointId]
    //         ? ''
    //         : (obj[currentItem.pointId] = true && prevArr.push(currentItem));
    //       return prevArr;
    //     }, []);
    //     return arr;
    //   });
    // } else {
    //   data = data.map(arr => {
    //     let obj = {};
    //     arr = arr.reduce(function(prevArr, currentItem) {
    //       obj[currentItem.pointid]
    //         ? ''
    //         : (obj[currentItem.pointid] = true && prevArr.push(currentItem));
    //       return prevArr;
    //     }, []);
    //     return arr;
    //   });
    // }
  }
  //console.log(data);
  if (Object.prototype.toString.call(data) === '[object Array]') {
    if (type === 5) {
      data = data.map(arr => {
        if (subtype === '2') {
          return arr.map(item => {
            return [item.wspd, item.thrust];
          });
        } else {
          return arr.map(item => {
            return [item.wspd, item.power];
          });
        }
      });
    }
    // if (type === 7) {
    //   data = data.map(arr => {
    //     return arr.map(item => {
    //       return [item.wspd, item.power];
    //     });
    //   });
    // }
    if (type === 3) {
      data = data.map(arr => {
        return arr.map(item => {
          return [item.wspd, item.power];
        });
      });
    }
    if (type === 4) {
      data = data.map(arr => {
        return arr.map(item => {
          return [item.wspd, item.thrust];
        });
      });
    }
    // if (type === 10) {
    //   data = data.map(arr => {
    //     return arr.map(item => {
    //       return [item.ratio, item.value];
    //     });
    //   });
    // }
  } else {
    let newArr = [];
    for (let key in data) {
      newArr.push(data[key]);
    }
    // if (type === 7) {
    //   data = newArr.map(arr => {
    //     return arr.map(item => {
    //       return [item.wspd, item.power];
    //     });
    //   });
    // }
    if (type === 3) {
      data = newArr.map(arr => {
        return arr.map(item => {
          return [item.wspd, item.power];
        });
      });
    }
    if (type === 4) {
      data = newArr.map(arr => {
        return arr.map(item => {
          return [item.wspd, item.thrust];
        });
      });
    }
    // if (type === 10) {
    //   data = newArr.map(arr => {
    //     return arr.map(item => {
    //       return [item.ratio, item.value];
    //     });
    //   });
    // }
  }
  return data;
};
